import React from "react";
import "./SongComponent.scss";
import song from "./song.jpg"; // same directory

const SongComponent = ({
  title = "Our Song",
  thumbnailSrc = "./song.jpg",
  thumbnailAlt = "Song thumbnail",
  credits = [
    { role: "Lyrics", by: "Saman",            icon: "lyrics" },
    { role: "Melody", by: "Amal",             icon: "note"   },
    { role: "Vocal",  by: "Kamal",            icon: "mic"    },
    { role: "Cinematography", by: "Bimal",    icon: "camera" },
    { role: "Mixing & Mastering", by: "Wimal", icon: "sliders"},
  ],
}) => {
  const Icon = ({ name }) => {
    switch (name) {
      case "lyrics":
        return (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <path d="M4 4h16v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4z"></path>
            <path d="M8 8h8M8 12h5"></path>
          </svg>
        );
      case "note":
        return (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <path d="M9 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM15 6v9a3 3 0 1 0 2 2.83V8l4-1V4l-6 2z"></path>
          </svg>
        );
      case "mic":
        return (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <rect x="9" y="3" width="6" height="11" rx="3"></rect>
            <path d="M5 11a7 7 0 0 0 14 0M12 18v3M8 21h8"></path>
          </svg>
        );
      case "camera":
        return (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <path d="M3 8a3 3 0 0 1 3-3h2l2-2h4l2 2h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"></path>
            <circle cx="12" cy="13" r="4"></circle>
          </svg>
        );
      default:
        return (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <circle cx="12" cy="12" r="9"></circle>
          </svg>
        );
    }
  };

  return (
    <section className="song" aria-label="Featured Song">
      {/* Title at the top */}
      <br/>
      <h2 className="song__title">{title}</h2>

      {/* Thumbnail (no overlaid title) */}
      <figure className="song__hero">
        <img src={song} alt={thumbnailAlt} loading="lazy" decoding="async" />
      </figure>

      {/* Centered one-line credits without borders */}
      <ul className="song__credits">
        {credits.map((c, i) => (
          <li className="credit-line" key={i}>
            <span className="credit-line__icon"><Icon name={c.icon} /></span>
            <span className="credit-line__text">{c.role} by <strong>{c.by}</strong></span>
          </li>
        ))}
      </ul>
      <br/>
    </section>
    
  );
};

export default SongComponent;
